import React from 'react';

/**
 * PageHeader — shared page-level header pattern.
 *
 * Layout:
 *   ┌──────────────────────────────────────────┬──────────────┐
 *   │ H1 (28/600)                              │  actions     │
 *   │ subtitle (15, muted, 1.5)                │              │
 *   └──────────────────────────────────────────┴──────────────┘
 *
 * Bottom margin: 32px (var(--major-gap)).
 */
export const PageHeader = ({ title, subtitle, actions, className = '' }) => (
  <header
    className={['flex items-end justify-between gap-4 flex-wrap mb-8', className]
      .filter(Boolean)
      .join(' ')}
  >
    <div className="min-w-0">
      <h1 className="text-[28px] font-semibold tracking-[-0.02em] leading-[1.2] text-lb-ink-strong m-0">
        {title}
      </h1>
      {subtitle && (
        <p className="text-[15px] leading-[1.5] text-lb-muted mt-1.5 max-w-[720px] m-0">
          {subtitle}
        </p>
      )}
    </div>
    {actions && (
      <div className="flex items-center gap-2 flex-shrink-0 flex-wrap">{actions}</div>
    )}
  </header>
);
